import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import { callApi } from '../../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../../api/constant';
import { pageLinks } from '../../../utility/helper';
import { useNavigate } from 'react-router-dom';
import { ISection } from '../../../interfaces/sections';
import ConfirmationModal from '../../../components/UI/Modal/ConfirmationModal';
import useConfirmationModal from '../../../hooks/useConfirmationModal';
import { Link } from 'react-router-dom';

const Sections: React.FC = () => {
    const [sections, setSections] = useState<ISection[]>([]);
    const [loading, setLoading] = useState<boolean>(true); // Track loading state
    const [selected, setSelected] = useState(pageLinks[0]);

    const { showModal, modalProps, confirmAction } = useConfirmationModal();
    const navigate = useNavigate()

    useEffect(() => {
        getSections();
    }, [selected]);

    const getSections = async () => {
        try {
            setLoading(true); // Start loading
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + `sections/${selected.value}`, { method: 'GET' });
            setSections(response);
        } catch (error: any) {
            console.error('Failed to fetch sections:', error.message);
        } finally {
            setLoading(false); // End loading
        }
    };

    const handleSelect = (link: { label: string; value: string }) => {
        setSelected(link);
    };

    const deleteSection = async (id: string) => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + `sections/${id}`, { method: 'DELETE' });
            setSections((prevSections: ISection[]) => prevSections.filter(section => section.id !== id));
        } catch (error: any) {
            console.error('Failed to fetch sections:', error.message);
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteClick = (id: string) => {
        confirmAction({
            title: 'Confirm Delete',
            message: 'Are you sure you want to delete this section?',
            onConfirm: () => deleteSection(id),
        });
    };
    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">Sections</h1>
                <Link to={"/add-section"} className='btn app-btn-primary d-flex align-items-center gap-1'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                </svg> Add Sections</Link>
            </div>

            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                <div className="row">
                    {/* Page ID */}
                    <div className="mb-3 col-12 col-md-6">
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle bg-transparent text-secondary border"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {selected.label}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {pageLinks.map((link, index) => (
                                    <li key={index}>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleSelect(link)}
                                        >
                                            {link.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="app-card-body">
                    <div className="table-responsive">
                        <table className="table app-table-hover mb-0 text-left">
                            <thead>
                                <tr>
                                    <th className="cell">S.no.</th>
                                    <th className="cell">Page</th>
                                    <th className="cell">Title</th>
                                    <th className="cell">Order</th>
                                    <th className="cell">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td className="text-center" colSpan={5}>Loading sections...</td>
                                    </tr>
                                ) : sections.length === 0 ? (
                                    <tr>
                                        <td className="text-center" colSpan={5}>No sections available to display.</td>
                                    </tr>
                                ) : (
                                    sections.map((page, index) => (
                                        <tr key={page.id}>
                                            <td className="cell">#{index + 1}</td>
                                            <td className="cell"><span className="truncate">{page.page}</span></td>
                                            <td className="cell">{page.title}</td>
                                            <td className="cell">{page.order}</td>
                                            <td className="cell">
                                                <div className=' d-flex align-items-center gap-1'>
                                                    <a onClick={() => navigate('/edit-section/' + page.id)} className="btn btn-success px-2 py-1 text-white" href="#"><i className="bi bi-pen"></i></a>
                                                    <a onClick={() => handleDeleteClick(page.id)} className="btn btn-danger px-2 py-1 text-white" href="#"><i className="bi bi-trash3"></i></a>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    );
};

export default Sections;
